import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static targets = ["container", "scrollContainer"]
  static values = { date: String }

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create("ScheduleChannel", {
      connected: () => {
        console.log("Connected to schedule channel")
      },
      disconnected: () => {
        console.log("Disconnected from schedule channel")
      },
      received: (data) => {
        this.handleUpdate(data)
      }
    })

    // Auto-scroll to current time on page load if it's today
    this.scrollToCurrentTimeIfToday()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    if (this.consumer) {
      this.consumer.disconnect()
    }
  }

  handleUpdate(data) {
    switch(data.type) {
      case "appointment_updated":
        this.refreshView()
        break
      case "appointment_created":
        this.refreshView()
        break
      case "appointment_deleted":
        this.refreshView()
        break
      default:
        console.log("Unknown update type:", data.type)
    }
  }

  refreshView() {
    // Refresh the current view using Turbo
    window.location.reload()
  }

  scrollToCurrentTimeIfToday() {
    // Check if the displayed date is today
    const scheduleDate = new Date(this.dateValue)
    const today = new Date()
    
    // Compare dates (ignoring time)
    const isToday = scheduleDate.toDateString() === today.toDateString()
    
    if (!isToday) {
      return // Don't scroll if it's not today
    }
    
    const now = new Date()
    const currentHour = now.getHours()
    const currentMinute = now.getMinutes()
    
    // Check if current time is within schedule range (8h-23h)
    if (currentHour < 8 || currentHour >= 23) {
      return // Don't scroll if current time is outside schedule range
    }
    
    // Format current time as HHMM to match the data-time attributes
    const currentTimeStr = currentHour.toString().padStart(2, '0') + 
                          (Math.floor(currentMinute / 5) * 5).toString().padStart(2, '0')
    
    // Use setTimeout to ensure the DOM is fully rendered
    setTimeout(() => {
      // Find the scroll container (the div with overflow-auto)
      const scrollContainer = this.hasScrollContainerTarget 
        ? this.scrollContainerTarget 
        : this.element.querySelector('.schedule-content-scroll')
      
      if (!scrollContainer) {
        return
      }
      
      // Find the first time slot element that matches the current time
      const timeSlot = this.element.querySelector(`[data-time="${currentTimeStr}"]`)
      
      if (timeSlot) {
        // Calculate position relative to the scroll container
        const containerRect = scrollContainer.getBoundingClientRect()
        const slotRect = timeSlot.getBoundingClientRect()
        
        // Current scroll position of the container
        const currentScrollTop = scrollContainer.scrollTop
        
        // Calculate the target scroll position
        // slotRect.top is relative to viewport, containerRect.top is container's position in viewport
        // The difference plus current scroll gives us the absolute position within the container
        const slotPositionInContainer = slotRect.top - containerRect.top + currentScrollTop
        
        // Get the height of the sticky column headers (64px as defined in the template)
        const stickyHeaderHeight = 64
        
        // Scroll to position the time slot just below the sticky headers
        scrollContainer.scrollTo({
          top: slotPositionInContainer - stickyHeaderHeight - 20, // 20px padding for better visibility
          behavior: 'smooth'
        })
      }
    }, 150)
  }
}
